import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';
import { resolveFaqContent } from '../utils/faqLocale';

export default function FAQ({ cms }) {
  const { t, locale } = useI18n();
  const { faqs: fallbackFaqs } = useBookersContent();
  const [open, setOpen] = useState(0);
  const { title, description, items } = resolveFaqContent(cms, locale, t, fallbackFaqs);

  return (
    <section className="bg-[#fafafb] border-y border-black/5">
      <div className="mx-auto max-w-3xl px-5 lg:px-8 section-pad">
        <div className="text-center reveal">
          <h2 className="font-display text-4xl md:text-5xl text-[#0b0b0f]">{title}</h2>
          <p className="text-[#55555f] mt-4 text-lg">{description}</p>
        </div>
        <div className="mt-12 space-y-3">
          {items.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="reveal bg-white rounded-2xl border border-black/5 overflow-hidden">
                <button type="button" onClick={() => setOpen(isOpen ? -1 : i)} className="w-full flex items-center justify-between gap-4 p-5 text-left">
                  <span className="font-semibold text-[#0b0b0f] text-[16px]">{faq.q}</span>
                  <Plus size={20} className={`shrink-0 text-[#76B828] transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-[#6b6b73] leading-relaxed text-[15px]">{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
